import { z } from 'zod/v4';

export const roleSchema = z.enum([
  'ALK Administrator',
  'ALK Support',
  'Partner Administrator',
  'Support',
  'Company Administrator',
  'User',
  'Fleet Manager',
  'Fleet User',
  'Fleet Support',
  'Product Key Auth',
  'ReadOnly',
  'Basic User',
]);

export type Role = z.infer<typeof roleSchema>;
